import { Input } from 'antd';
import { useEffect } from 'react';
import './TextInputStyle.css';

const IntegerInput = props => {
    const { def, data, onChange, state, warning } = props;
    const err = warning !== undefined && warning !== '' ? "error" : "";

    useEffect(() => {
        var elem = document.getElementById(def.dataKey);
        elem.onkeydown = ev => {
            if (ev.code.includes('Key') || ev.code === 'Period' || ev.code === 'Comma' || ev.code === 'Space' || ev.code === 'NumpadDecimal') ev.preventDefault();
            if (def.maxLength && elem.value.length >= def.maxLength && (ev.code.includes('Digit') || ev.code.includes('Numpad'))) ev.preventDefault();
        }
    
    }, []);

    useEffect(() => {
        if (data && data.length > 0 && isNaN(data)) {
            onChange(def.dataKey, data.replace(/\D/g, ''))
        }
    
    }, [data]);

    const mustBeMaxLength = () => { //Would like to have a MinLength field in the DB instead of this
        if (def.dataKey.toUpperCase().includes('NPI') || def.dataKey.toUpperCase().includes('COSMO')) {
            return true;
        }
        else return false;
    }

    const checkInteger = (value) => {
        if (isNaN(value) && value !== '') return;
        var strVal = value === null ? '' : value.toString();

        if (def.maxLength && strVal.length > def.maxLength) return;

        let newWarning = '';
        if (state.required || strVal.length > 0) {
            //mustBeMaxLength
            if (def.maxLength && strVal.length > 0 && strVal.length < def.maxLength && mustBeMaxLength()) {
                newWarning = `"${def.label}" must be ${def.maxLength} digits`
                onChange(def.dataKey, strVal, newWarning);
            }
            //must be at least minlength
            else if (def.minLength && strVal.length < def.minLength) {
                newWarning = `"${def.label}" must be at least ${def.minLength} digits`
                onChange(def.dataKey, strVal, newWarning);
            }
            //no minlength defined
            else {
                onChange(def.dataKey, strVal);
            }
        }
        else { //does this else ever get hit??
            onChange(def.dataKey, strVal);
        }

    }

    return <Input
        id={def.dataKey}
        data-inputinteger={'integerinput_de'}
        className={'basicinput_de'}
        status={err}
        readOnly={state.readonly}
        disabled={state.readonly}
        value={data}
        onChange={ev => checkInteger(ev.target.value)}
        placeholder={def.placeholder}
        controls={false}
    />
}

export default IntegerInput;
